import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { ApiResponse } from '../../../../../common/api/response.types'
import {
  ILedgerDepositRequest,
  ILedgerDepositResult,
  ILedgerWalletBalance,
  LedgerWalletOwnerType,
} from './types'

export const getLedgerWalletBalance = (ownerType: LedgerWalletOwnerType, id: number) =>
  axios.get<ApiResponse<ILedgerWalletBalance>>(
    `${API_URL}/api/internal/${ownerType}/${id}/ledger-wallet-balance`
  )

// CPAYMENT-1483 — credit the work wallet (capital injection).
export const postLedgerDeposit = (
  ownerType: LedgerWalletOwnerType,
  id: number,
  body: ILedgerDepositRequest
) =>
  axios.post<ApiResponse<ILedgerDepositResult>>(
    `${API_URL}/api/internal/ledger-deposits/${ownerType}/${id}`,
    body
  )
